import moment from 'moment'
import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'
import Overdue from './icons/Overdue'
import NextScanDateIcon from './icons/NextScanDateIcon'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  container: {
    marginRight: 10
  },
  overdueText: {
    color: 'rgba(235, 88, 88, 1)'
  }
}))

const NextScanDate = ({ nextScanDate }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const nextScanDateStartOfDay = moment(nextScanDate).startOf('day')
  const nextScanInDays = Math.abs(moment().startOf('day').diff(nextScanDateStartOfDay, 'days'))

  const isOverdue = moment(nextScanDate).isBefore(moment(), 'day')

  return (
    <Grid container alignItems="center" spacing={1} className={classes.container}>
      <Grid item>{isOverdue ? <Overdue /> : <NextScanDateIcon />}</Grid>
      <Grid item>
        <DazzedParagraph14 className={isOverdue ? classes.overdueText : ''}>
          {isOverdue
            ? t('pages.copilotControl.widgets.scanningSchedule.scanOverdue', { days: nextScanInDays })
            : nextScanInDays === 0
            ? t('pages.copilotControl.widgets.scanningSchedule.nextScanIsToday')
            : t('pages.copilotControl.widgets.scanningSchedule.nextScan', { days: nextScanInDays })}
        </DazzedParagraph14>
      </Grid>
    </Grid>
  )
}

export default NextScanDate
